// @flow

import * as React from 'react';
import Relay from 'react-relay/classic';

const exampleQuery = (slug) => `query {
  organization(slug: "${slug}") {
    auditEvents(first: 500) {
      edges {
        node {
          type
          occurredAt
          actor {
            name
          }
          subject {
            name
            type
          }
          data
        }
      }
    }
  }
}`;

type Props = {
  organization: {
    slug: string
  }
};

class AuditLogExport extends React.PureComponent<Props> {
  render() {
    const linkClassName = 'text-decoration-none lime hover-lime hover-underline';

    return (
      <div>
        <p>
          Your organizationʼs audit log can be queried and exported using the <a href="/docs/graphql-api" className={linkClassName}>GraphQL API</a>.
        </p>
        <p>For example:</p>
        <pre className="code">
          {exampleQuery(this.props.organization.slug)}
        </pre>
        <p>
          See the <a href="/docs/graphql-api" className={linkClassName}>GraphQL Documentation</a> for more information.
        </p>
      </div>
    );
  }
}

export default Relay.createContainer(AuditLogExport, {
  fragments: {
    organization: () => Relay.QL`
      fragment on Organization {
        slug
      }
    `
  }
});
